export default "__VITE_ASSET__sF80A4ma__"